import React, {ReactNode} from 'react';

import styles from './ListActions.module.scss';

interface IListActionsProps {
    children: ReactNode,
}

const ListActions: React.FC<IListActionsProps> = ({children}) => (
    <div className={styles.actions}>{children}</div>
);

export default ListActions;
